// extracted by mini-css-extract-plugin
export default {"container":"A11y_container__S22Re","controls":"A11y_controls__36Mg3","a11y":"A11y_a11y__coCsG","option":"A11y_option__s7jeH","button":"A11y_button__CG-mw"};